/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useState } from "react";
import { ElabTimer } from "../../components/elabtimer";
import { ElabPagination } from "./ElabPagination";
import { assessmentFlow } from "../../../components/constants/constants";

const levelColors = {
  B1: "bg-[#9333ea]",
  B2: "bg-[#EA580C]",
  C1: "bg-[#db2777]",
};

export const ElabAssessmentHeader = ({
  assessmentStarted,
  isReview,
  creatQuizDataAndSubmit,
  data,
  isStopTimer,
  setIsStopTimer,
  timer,
  setShowTimeWarning,
  CurrentSection,
  totalSections,
  answers,
  visited_pages,       
  setCurrentPage,   
  currentSectionPage,
  setCurrentSectionPage,
  pagination_color_decision,
  isAiGradingexercise,      
  AisubmissionCounter,
  setAisubmissionCounter,
}) => {
  const [saveOnTimeOver, SetSaveOnTimeOver] = useState(false);

    const getLevelColor = () => {
      const level = Array.isArray(data.level[0]) ? data.level[0][0] : data.level[0];
      return levelColors[level];
    };

  return (
    <div className={`${getLevelColor()} pt-8 pb-16`}>
      <div className="container mx-auto px-4">
        {/* Header Content */}
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-semibold text-white">{data.label}</h1>
          {!isReview && data && data.status && (
            <div className="bg-white/10 px-4 py-2 rounded-full">
              <span className="text-sm font-medium text-white">
                <ElabTimer
                  isStopTimer={isReview ? true : isStopTimer}
                  data={data}
                  localSpentTime={timer}
                  test_time_out={data.allow_late_submissions ? false : true}
                  setShowTimeWarning={setShowTimeWarning}
                  totalTimeInSeconds={data.time_allowed_in_minutes}
                  onStop={(props) => {
                    if (!saveOnTimeOver && !data.allow_late_submissions) {
                      creatQuizDataAndSubmit();
                      alert(
                        "Your test was automatically submitted because you ran out of time."
                      );
                      SetSaveOnTimeOver(true);
                      setIsStopTimer(true);
                    }
                  }}
                />
              </span>
            </div>
          )}
        </div>

        {/* Progress Steps */}
      {isReview ||
          data.assessment_flow ===
          assessmentFlow.SEQUENTIAL_EARLY_STOP ? null : (
        <ElabPagination
          data={data}
          totalSections={totalSections}
          answers={answers}
          visited_pages={visited_pages}
          currentPage={CurrentSection}
          setCurrentPage={setCurrentPage}
          currentSectionPage={currentSectionPage}
          setCurrentSectionPage={setCurrentSectionPage}
          pagination_color_decision={pagination_color_decision}
          isAiGradingexercise={isAiGradingexercise}
          AisubmissionCounter={AisubmissionCounter}
          setAisubmissionCounter={setAisubmissionCounter}
        />
          )}
      </div>
    </div>
  );
};
